import { SettingOutlined } from '@ant-design/icons'
import { Popconfirm, Popover } from 'antd'
import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import TableBox from '../../../Components/TableBox/TableBox'
import FilterLayout from '../../../Layout/FilterLayout'
import TableLayout from '../../../Layout/TableLayout'
import AssetFilter from './AssetFilter'

export default function Asset() {
  const history = useHistory()

  const columns = [
    {
      title: 'Item Name',
      dataIndex: 'itemName'
    },
    {
      title: 'Item Category',
      dataIndex: 'itemCategory'
    },
    {
      title: 'Requested Date',
      dataIndex: 'requestedDate'
    },
    {
      title: 'From Date',
      dataIndex: 'fromDate'
    },
    {
      title: 'To Date',
      dataIndex: 'toDate'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      title: 'Approval Person',
      dataIndex: 'approvalPerson'
    },
    {
      title: 'Issue Date',
      dataIndex: 'issueDate'
    },
    {
      title: 'Action',
      dataIndex: 'custom_action',
      render: (text, row) => (
        <Popover placement="bottomRight" content={tableActions(row)} trigger="click">
          <div className="btn-group">
            <button type="button" className="btn glow dropdown-toggle">
              <SettingOutlined /> <span className="caret" />
            </button>
          </div>
        </Popover>
      )
    }
  ]

  const tableActions = () => (
    <div className="action-buttons">
      <ul>
        <li>
          <Link to="#">
            <i className="flaticon-edit-1" /> Edit
          </Link>
        </li>
        <li>
          <Popconfirm title="Sure to delete?">
            <Link to="#">
              <i className="flaticon-delete-2" /> Delete
            </Link>
          </Popconfirm>
        </li>
      </ul>
    </div>
  )

  return (
    <FilterLayout
      addButton={{
        title: 'Add New Asset',
        onClick: () => history.push('/app/add-asset'),
        access: 'add-asset'
      }}
      filter={<AssetFilter />}>
      <TableLayout title="Asset List" exportUrl="asset/export">
        <TableBox columns={columns} />
      </TableLayout>
    </FilterLayout>
  )
}
